import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRestaurantMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "restaurant-menu" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 3,
			y: .75,
			width: 19.5,
			height: 22.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 1.5,
			y1: 5.25,
			x2: 4.5,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 1.5,
			y1: 9.75,
			x2: 4.5,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 1.5,
			y1: 14.25,
			x2: 4.5,
			y2: 14.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 1.5,
			y1: 18.75,
			x2: 4.5,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "cls-1",
			cx: 10.5,
			cy: 8.625,
			rx: 2.25,
			ry: 2.625
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 10.5,
			y1: 11.25,
			x2: 10.5,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 16.5,
			y1: 11.25,
			x2: 16.5,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15,6V9.75a1.5,1.5,0,0,0,1.5,1.5h0A1.5,1.5,0,0,0,18,9.75V6"
		})
	]
});
export default SvgRestaurantMenu;
